import { useFormikContext } from 'formik'
import * as React from 'react'
import { useTranslatable } from 'src/hooks/locale/utils'
import { Button } from 'src/tailwind/components/Button'

export interface SearchCancelButtonsProps {
  readonly isDirty: boolean
  readonly canCancel: boolean
  readonly onCancel: () => void
  readonly submitLabel?: string
  readonly cancelLabel?: string
}

export function SearchCancelButtons({
  isDirty,
  canCancel,
  onCancel,
  submitLabel,
  cancelLabel,
}: SearchCancelButtonsProps): React.ReactElement {
  const formik = useFormikContext()
  const t = useTranslatable()

  return (
    <div className="flex w-full justify-end">
      <Button
        variant="red"
        disabled={formik.isSubmitting || !isDirty}
        type="submit"
        onClick={() => formik.submitForm()}
      >
        {submitLabel ?? t('common:search')}
      </Button>
      <Button
        variant="yellow"
        type="reset"
        disabled={formik.isSubmitting || canCancel}
        className="ml-2"
        onClick={onCancel}
      >
        {cancelLabel ?? t('common:cancel')}
      </Button>
    </div>
  )
}
